<p-dialog [(visible)]="visible" [modal]="true" [style]="{ width: '70vw' }"
    [breakpoints]="{ '960px': '80vw', '640px': '95vw' }" [draggable]="false" [resizable]="false" (onHide)="onClose()"
    header="Create a New Regulatory Change Assessment" styleClass="create-rca-upload-dialog">
    <div class="dialog-content">
        <!-- Instructions Section -->
        <div class="instructions-section">
            <div class="section-title">Instructions</div>

            <div class="step-block">
                <div class="step-header">Step 1</div>
                <ul>
                    <li>
                        Click the link and the file will be downloaded to your computer or
                        mobile device.
                    </li>
                </ul>
            </div>

            <div class="step-block">
                <div class="step-header">Step 2</div>
                <ul>
                    <li>Open the downloaded file.</li>
                    <li>
                        Carefully read each field in the form and provide the required
                        information.
                    </li>
                    <li>
                        Make sure all mandatory
                        fields are filled.
                    </li>
                    <li>
                        Double-check for any spelling errors, incorrect data, or missing
                        entries.
                    </li>
                    <li>Save the file after completion:</li>
                    <li class="sub-instruction">
                        For Example: name the file with your Full Name + Form Type (e.g.,
                        John_Doe_ApplicationForm.xlsx).
                    </li>
                </ul>
            </div>

            <div class="step-block">
                <div class="step-header">Step 3</div>
                <ul>
                    <li>Return to the form upload page.</li>
                    <li>Click the "Upload" button or "Choose File" field.</li>
                    <li>Click Submit or Finish to complete the process.</li>
                </ul>
            </div>
        </div>

        <!-- Upload Section -->
        <div class="upload-section">
            <div class="step-block">
                <div class="step-header">Step 1</div>
                <p>
                    Click on the link given below to download the template:
                </p>
                <div class="download-template">
                    <!-- Using a placeholder for Excel Icon, replace with actual image path -->
                    <!-- Make sure assets/excel_icon.png exists or use a PrimeIcons icon -->
                    <!-- <img src="assets/excel_icon.png" alt="Excel Icon" class="excel-icon" /> -->
                     <i class="pi pi-file-excel"></i>
                    <a href="#" class="download-link" (click)="downloadTemplate($event)">Download Template</a>
                </div>
            </div>

            <div class="step-block">
                <div class="step-header">Step 2</div>
                <p>Click the "Upload" button and choose the file.</p>

                <input type="file" #fileInput style="display: none;" (change)="onFileSelected($event)"
                    accept=".xlsx,.csv" />

                <div class="description-editor-container">
                    <label for="fileDescription" class="editor-label">
                        Description 
                        <span class="required">*</span>
                    </label>
                    <p-editor 
                        [(ngModel)]="fileDescription" 
                        [style]="{'height':'200px'}"
                        placeholder="Enter a min 50 and max 4000 characters"
                        [modules]="editorModules">
                    </p-editor>
                    <small class="character-counter">
                        {{ getPlainTextLength() }} / 4000 characters (min 50 required)
                    </small>
                </div>

                <!-- Display selected file name and validation messages -->
                <div *ngIf="selectedFile" class="selected-file-info">
                    Selected File: <strong>{{ selectedFile.name }}</strong>
                </div>
                <div *ngIf="uploadError" class="upload-error">
                    {{ uploadError }}
                </div>

                <p-button label="Upload" icon="pi pi-upload" styleClass="p-button-success upload-button"
                    (onClick)="triggerFileInput()" [disabled]="isProcessing"></p-button>
                    
            </div>
        </div>
    </div>

    <ng-template pTemplate="footer">
        <p-button label="Save as Draft" styleClass="p-button-secondary footer-button"
            (onClick)="saveAsDraft()" [disabled]="isProcessing"></p-button>
        <p-button label="Submit" styleClass="p-button-success footer-button"
            (onClick)="onSubmit()" [disabled]="isProcessing"></p-button>
    </ng-template>
</p-dialog>